module.exports = __webpack_public_path__ + "static/media/AddUser.b1c129b0.svg";